module.exports = __webpack_public_path__ + "static/media/scheduler-logo.54963043.svg";